import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Services.css'
import Header from '../components/Header.jsx'
import Footer from '../components/Footer.jsx'

const services = [
  { title: 'Maintenance', image: '/images/deck2.jpg' },
  { title: 'Stone', image: '/images/stone.jpg' },
  { title: 'Deck', image: '/images/deck.jpg' },
  { title: 'Fence', image: '/images/deck0.jpg' },
  { title: 'Irrigation', image: '/images/planting2.jpg' },
  { title: 'Planting', image: '/images/planting.jpg' },
]

const emptyForm = {
  name: '',
  phone: '',
  email: '',
  location: '',
  description: '',
}

const ServicesSection = () => {
  const [form, setForm] = useState(emptyForm)
  const [statusMessage, setStatusMessage] = useState('')
  const [isSending, setIsSending] = useState(false)

  // Updates the correct form field whenever the user types.
  const handleChange = (event) => {
    const { name, value } = event.target

    const updatedValue =
      name === 'phone' ? value.replace(/\D/g, '') : value

    setForm((previousForm) => ({
      ...previousForm,
      [name]: updatedValue,
    }))
  }

  // Sends the form information to the Netlify email function.
  const submit = async (event) => {
    event.preventDefault()
    setStatusMessage('')
    setIsSending(true)

    try {
      const response = await fetch('/.netlify/functions/send-estimate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      })

      const result = await response.json()

      if (!response.ok) {
        throw new Error(
          result.message || 'Unable to send the estimate request.'
        )
      }

      setStatusMessage('Your estimate request was sent successfully.')
      setForm(emptyForm)
    } catch (error) {
      console.error('Estimate request error:', error)
      setStatusMessage('Failed to send message. Please try again.')
    } finally {
      setIsSending(false)
    }
  }

  // Hides an image if the requested image file cannot be found.
  const handleImageError = (event) => {
    event.currentTarget.style.display = 'none'
  }

  return (
    <div>
      <section className="services-section">
        <Header />

        <h2>Our Landscaping Services</h2>

        <div className="services-scroll">
          {services.map((service, index) => (
            <Link
              to={`/${service.title.toLowerCase()}`}
              className="service-card"
              key={service.title}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="image-wrapper">
                <img
                  src={service.image}
                  alt={service.title}
                  onError={handleImageError}
                />

                <div className="service-glow"></div>
              </div>

              <div className="service-overlay">
                <span className="service-text">{service.title}</span>
              </div>
            </Link>
          ))}
        </div>

        <form
          className="contact-form"
          id="quote-form"
          onSubmit={submit}
        >
          <h2>Request an Estimate</h2>

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={form.phone}
            onChange={handleChange}
            maxLength="10"
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="location"
            placeholder="Location"
            value={form.location}
            onChange={handleChange}
            required
          />

          <textarea
            name="description"
            placeholder="Brief Description"
            value={form.description}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit" disabled={isSending}>
            {isSending ? 'Sending...' : 'Send'}
          </button>

          {statusMessage && (
            <p
              className="status-message"
              role="status"
              aria-live="polite"
            >
              {statusMessage}
            </p>
          )}
        </form>
      </section>

      <Footer />
    </div>
  )
}

export default ServicesSection